import { render, staticRenderFns } from "./CellText.vue?vue&type=template&id=117114d4&"
import script from "./CellText.vue?vue&type=script&lang=js&"
export * from "./CellText.vue?vue&type=script&lang=js&"
import style0 from "./CellText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports